import React, { useContext } from "react";
import { ExchangeRateContext } from "../App";

const ExchangeRateDisplay = () => {
    const { exchangeRate, error } = useContext(ExchangeRateContext);

    return (
        <div className="text-center my-4">
            <h3>Current Exchange Rate</h3>
            {exchangeRate !== null ? (
                <p>
                    <strong>
                        1 USD = {exchangeRate.toFixed(2)} 6DO [or {(exchangeRate / 100 * 2).toFixed(2)} 6DC]
                    </strong>
                </p>
            ) : error ? (
                <p style={{ color: "red" }}>Error fetching exchange rate: {error}</p>
            ) : (
                <p>Loading exchange rate...</p>
            )}
        </div>
    );
};

export default ExchangeRateDisplay;
